import { Link } from 'react-router-dom';

const guides = [
  {
    title: 'Complete ACBuy Spreadsheet Guide 2026',
    description: 'Everything you need to know about using ACBuySpreadsheet — from getting started to advanced tips for finding the best deals.',
    path: '/acbuy-spreadsheet-guide',
    tag: 'Updated',
    tagColor: 'bg-primary-100 text-primary-700',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20sleek%20laptop%20displaying%20clean%20interface%2C%20surrounded%20by%20fashion%20accessories%20scattered%20on%20warm%20sand%20desk%2C%20soft%20natural%20daylight%2C%20editorial%20photography%2C%20clean%20organized%20composition%2C%20warm%20neutral%20background%2C%20productivity%20aesthetic&width=700&height=450&seq=guide-main-v2-01&orientation=landscape',
  },
  {
    title: 'Shipping & QC Guide',
    description: 'Learn how to verify product quality, understand shipping timelines, and ensure a safe shopping experience with ACBuy spreadsheets.',
    path: '/acbuy-spreadsheet-guide#safety',
    tag: 'Essential',
    tagColor: 'bg-accent-100 text-accent-700',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20and%20quality%20checklist%20on%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20editorial%20photography%2C%20clean%20minimal%20composition%2C%20warm%20neutral%20background%2C%20delivery%20and%20quality%20concept%2C%20organized%20packaging%20aesthetic&width=700&height=450&seq=guide-shipping-v2-02&orientation=landscape',
  },
  {
    title: 'Safety & Trust Guide',
    description: 'Stay safe while shopping — our comprehensive safety tips help you avoid scams and verify legitimate spreadsheet links before purchasing.',
    path: '/acbuy-spreadsheet-guide#safety',
    tag: 'Important',
    tagColor: 'bg-secondary-200 text-secondary-800',
    imageUrl: 'https://readdy.ai/api/search-image?query=Shield%20icon%20and%20verified%20checkmark%20next%20to%20shopping%20items%20on%20warm%20beige%20surface%2C%20soft%20studio%20lighting%2C%20editorial%20photography%2C%20clean%20trust%20concept%20composition%2C%20warm%20neutral%20background%2C%20safety%20and%20security%20theme&width=700&height=450&seq=guide-safety-v2-03&orientation=landscape',
  },
];

export default function GuidesSection() {
  return (
    <section id="guides" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-12">
          <div className="flex-1">
            <p className="text-xs font-semibold text-primary-500 uppercase tracking-wider mb-3">
              Latest Guides
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              Expert <strong>ACBuy Spreadsheet</strong> Buying Guides
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            Stay informed with our weekly-updated <strong>acbuy spreadsheet guide</strong> collection — designed to help beginners and experienced shoppers alike.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {guides.map((guide, idx) => (
            <Link
              key={guide.path}
              to={guide.path}
              className="group bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.01] cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={guide.imageUrl}
                  alt={`ACBuySpreadsheet guide: ${guide.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span
                  className={`absolute top-3 left-3 px-3 py-1 rounded-full text-xs font-semibold ${guide.tagColor}`}
                >
                  {guide.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors">
                  {guide.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{guide.description}</p>
                <div className="mt-4 flex items-center gap-1 text-sm font-semibold text-primary-500">
                  Read Guide <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}